/**
 * autoclass-embed-block.js
 * File for handling embed blocks
 * 
 * Make core embed blocks look & feel like custom blocks 
 * by wrapping them in sections
 */

jQuery(document).ready(function($) {

    $('.wp-block-embed-youtube, .wp-block-embed-vimeo').each(function() {
        $(this).wrap( "<section class='block block-embed alignfull my-0 py-5 py-xl-6'><div class='container'></div></section>" );
    });

});
